import { Component } from 'vue'

import LinkIcon from '@/assets/link.svg?component'
import AppleMusicIcon from '@/assets/socials/applemusic.svg?component'
import FacebookIcon from '@/assets/socials/facebook.svg?component'
import InstagramIcon from '@/assets/socials/instagram.svg?component'
import SoundCloudIcon from '@/assets/socials/soundcloud.svg?component'
import SpotifyIcon from '@/assets/socials/spotify.svg?component'
import TiktokIcon from '@/assets/socials/tiktok.svg?component'
import XIcon from '@/assets/socials/x.svg?component'
import YoutubeIcon from '@/assets/socials/youtube.svg?component'

export const DEFAULT_RESIDENCY_LINK_ICON = 'link'

export const RESIDENCY_LINK_ICON_NAMES = [
  'facebook',
  'instagram',
  'link',
  'spotify',
  'tiktok',
  'x',
  'youtube',
  'soundcloud',
  'applemusic',
] as const

export type ResidencyLinkIconName = (typeof RESIDENCY_LINK_ICON_NAMES)[number]

/**
 * Shape of a single entry in the icon-picker dropdown. `displayName` is the
 * brand-correct label rendered in the Select. It is intentionally NOT named
 * `label` to avoid confusion with `ResidencyExternalLinkRead.label` (the link
 * title typed by the editor).
 */
export type ResidencyLinkIconOption = {
  name: ResidencyLinkIconName
  displayName: string
  component: Component
}

export const iconComponentByName: Record<ResidencyLinkIconName, Component> = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  link: LinkIcon,
  spotify: SpotifyIcon,
  tiktok: TiktokIcon,
  x: XIcon,
  youtube: YoutubeIcon,
  soundcloud: SoundCloudIcon,
  applemusic: AppleMusicIcon,
}

export const RESIDENCY_LINK_ICON_DISPLAY_NAMES: Record<ResidencyLinkIconName, string> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  link: 'Link',
  spotify: 'Spotify',
  tiktok: 'TikTok',
  x: 'X',
  youtube: 'YouTube',
  soundcloud: 'SoundCloud',
  applemusic: 'Apple Music',
}

export const RESIDENCY_LINK_ICON_OPTIONS: ResidencyLinkIconOption[] = RESIDENCY_LINK_ICON_NAMES.map(
  name => ({
    name,
    displayName: RESIDENCY_LINK_ICON_DISPLAY_NAMES[name],
    component: iconComponentByName[name],
  }),
)

export function isResidencyLinkIconName(value: string): value is ResidencyLinkIconName {
  return (RESIDENCY_LINK_ICON_NAMES as readonly string[]).includes(value)
}
